const complaintEvaluateRouter = [
  {
    path: '/complaint-evaluate',
    name: 'ComplaintEvaluate',
    component: () => import('@/views/sidebar/complaint-evaluate'),
    meta: {
      title: '投诉与评价'
    },
    children: [
      {
        path: 'evaluate',
        name: 'Evaluate',
        component: () => import('@/views/sidebar/complaint-evaluate/evaluate'),
        meta: {
          title: '评价'
        }
      },
      {
        path: 'complaint',
        name: 'Complaint',
        component: () => import('@/views/sidebar/complaint-evaluate/complaint'),
        meta: {
          title: '反馈'
        }
      }
    ]
  }
]
export default complaintEvaluateRouter
